export default "__VITE_ASSET__23d34f18__"